(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_search-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('SearchPageInput--{{ block.id }}');
  const clearBtn = document.getElementById('clear-search-btn--{{ block.id }}');
  if (!input || !clearBtn) return;

  const toggleClear = () => {
    clearBtn.style.display = input.value.trim() ? 'block' : 'none';
  };

  toggleClear();
  input.addEventListener('input', toggleClear);

  // Автофокус + курсор в конец
  input.focus();
  if (input.value) {
    input.setSelectionRange(input.value.length, input.value.length);
    toggleClear();
  }

  // Живой поиск
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => input.form.submit(), 400);
  });
});
  } catch(e) { console.error(e); }
})();

})();
